import { StateCreator } from "zustand";

import { RootStore } from "./";

export interface MeasureActions {
	openMeasureTool: () => void;
}

export type MeasureStore = MeasureActions;

export const createMeasureSlice: StateCreator<
	RootStore,
	[],
	[],
	MeasureStore
> = (set) => ({
	openMeasureTool: () => set({ currentMapToolView: "measure" }),
});
